<template>
  <div class="calico-banner-page">
    <div class="calico-banner-container">
      <div class="calico-banner-row">
        <CalicoBanner
          v-if="show1"
          @close="show1 = false"
        >
          <p class="body--medium">
            Message
          </p>
          <div style="width: fit-content;">
            <button class="button-utility button-utility--small">
              Button
            </button>
          </div>
        </CalicoBanner>
        <CalicoBanner
          v-if="show2"
          variant="success"
          @close="show2 = false"
        >
          <p class="body--medium">
            Message
          </p>
          <div style="width: fit-content;">
            <button class="button-utility button-utility--small">
              Button
            </button>
          </div>
        </CalicoBanner>
        <CalicoBanner
          v-if="show3"
          variant="error"
          @close="show3 = false"
        >
          <p class="body--medium">
            Message
          </p>
          <div style="width: fit-content;">
            <button class="button-utility button-utility--small">
              Button
            </button>
          </div>
        </CalicoBanner>
      </div>
      <div
        class="calico-banner-row"
        style="max-width: 400px;"
      >
        <CalicoBanner fixed>
          <p class="body--medium">
            Message
          </p>
        </CalicoBanner>
      </div>
    </div>
  </div>
</template>

<script>
import CalicoBanner from '@/components/calico/banner/index.vue';

export default {
  name: 'CalicoBannerPage',
  components: {
    CalicoBanner,
  },
  data() {
    return {
      show1: true,
      show2: true,
      show3: true
    }
  }
};
</script>

<style lang="scss">
.calico-banner-page {
  display: flex;
  justify-content: center;
  align-items: center;
  .calico-banner-container {
    @include stack-space($space-large);
    @include inset-space($space-large);
    width: 100%;
    .calico-banner-row {
      @include inline-space($space-large);
      @include inset-space($space-large);
    }
  }
}
</style>